/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PrescriptionMedication } from './PrescriptionMedication';
import {
    PrescriptionMedicationFromJSON,
    PrescriptionMedicationFromJSONTyped,
    PrescriptionMedicationToJSON,
} from './PrescriptionMedication';

/**
 * 
 * @export
 * @interface PatientMedicationValue
 */
export interface PatientMedicationValue {
    /**
     * 
     * @type {string}
     * @memberof PatientMedicationValue
     */
    name: string;
    /**
     * 
     * @type {PrescriptionMedication}
     * @memberof PatientMedicationValue
     */
    prescription_medication?: PrescriptionMedication;
    /**
     * 
     * @type {number}
     * @memberof PatientMedicationValue
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientMedicationValue
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedicationValue
     */
    status?: string;
}

/**
 * Check if a given object implements the PatientMedicationValue interface.
 */
export function instanceOfPatientMedicationValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PatientMedicationValueFromJSON(json: any): PatientMedicationValue {
    return PatientMedicationValueFromJSONTyped(json, false);
}

export function PatientMedicationValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientMedicationValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'prescription_medication': !exists(json, 'prescription_medication') ? undefined : PrescriptionMedicationFromJSON(json['prescription_medication']),
        'date': !exists(json, 'date') ? undefined : json['date'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function PatientMedicationValueToJSON(value?: PatientMedicationValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'prescription_medication': PrescriptionMedicationToJSON(value.prescription_medication),
        'date': value.date,
        'notes': value.notes,
        'status': value.status,
    };
}

